import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AngularFirestore } from '@angular/fire/firestore';
import { switchMap, map, filter, shareReplay } from 'rxjs/operators';

import * as AccountActions from '../account/account.actions';
import * as SpeciesActions from './species.actions';
import { Species } from '../../core/models/species.model';
import { of, combineLatest, Observable } from 'rxjs';
import { CabinetService } from '../../core/services/cabinet.service';
import { cloneDeep, keyBy, merge, orderBy, values } from 'lodash';


@Injectable()
export class SpeciesEffects {

  loadSpecies$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AccountActions.authenticated),
      switchMap(() => this.getSpecies()),
      switchMap(species => {
        return of(
          SpeciesActions.clearSpeciess(),
          SpeciesActions.addSpeciess({ speciess: species })
        );
      })
    );
  });

  logout$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AccountActions.logout),
      map(() => SpeciesActions.clearSpeciess())
    );
  });

  getSpecies(): Observable<Species[]> {
    return combineLatest([
      this.getDefaultSpecies(),
      this.getCabinetSpecies()
    ]).pipe(
      map(([defaultSpecies, cabinetSpecies]) => {
        const defaultSpeciesMap = keyBy(cloneDeep(defaultSpecies), 'value');
        const cabinetSpeciesMap = keyBy(cloneDeep(cabinetSpecies), 'value');
        const species = values(merge(defaultSpeciesMap, cabinetSpeciesMap));
        return orderBy(species, 'frequency', 'desc');
      }),
      shareReplay(1)
    );
  }

  getCabinetSpecies(): Observable<Species[]> {
    return this.cabinetService.cabinetId$.pipe(
      filter(id => !!id),
      switchMap(id => this.afs.collection('cabinets').doc(id).collection<Species>('species').valueChanges({ idField: 'id' })),
      shareReplay(1)
    );
  }

  getDefaultSpecies(): Observable<Species[]> {
    return this.afs.collection<Species>('species').valueChanges({ idField: 'id' }).pipe(
      shareReplay(1)
    );
  }

  constructor(
    private actions$: Actions,
    private afs: AngularFirestore,
    private cabinetService: CabinetService
  ) {}

}
